import { useEffect } from 'react'
import { ContactSection } from '../components/ContactForm'
import { SiteHeader, SiteFooter } from '../components/SiteHeader'
import { PortfolioGrid, usePortfolio } from '../components/PortfolioGrid'

export default function PortfolioPublic() {
  const { items, loaded } = usePortfolio()
  useEffect(() => { document.title = 'Portfolio | Pivot Média, production vidéo au Québec'; return () => { document.title = 'Pivot Média | Production Vidéo Industrielle au Québec' } }, [])
  return (
    <div className="min-h-screen bg-noir text-blanc">
      <SiteHeader />
      <section className="px-6 md:px-12 pt-16 pb-12">
        <div className="max-w-6xl mx-auto">
          <p className="text-orange uppercase tracking-[0.4em] text-xs mb-6">Portfolio</p>
          <h1 className="font-display text-5xl md:text-7xl tracking-wide leading-[0.95]">Nos réalisations</h1>
          <p className="text-acier text-lg mt-6 max-w-2xl font-light">
            Vidéos corporatives, industrielles, recrutement, reels et drone 4K, tournées et montées pour des entreprises du Québec. Cliquez sur un projet pour le visionner.
          </p>
        </div>
      </section>
      <section className="px-6 md:px-12 pb-24">
        <div className="max-w-6xl mx-auto">
          {!loaded ? <p className="text-acier">Chargement…</p>
            : items.length === 0 ? (
              <div className="border border-white/10 rounded p-12 text-center">
                <p className="font-display text-3xl tracking-wide">Nouveaux projets en montage</p>
                <p className="text-acier mt-3">Nos dernières réalisations arrivent bientôt. Écrivez-nous pour recevoir des exemples adaptés à votre industrie.</p>
                <a href="mailto:info@pivot-media.ca" className="inline-block mt-8 bg-orange hover:bg-orange-hover transition-colors px-8 py-4 uppercase tracking-widest text-sm font-bold rounded-sm">info@pivot-media.ca</a>
              </div>
            ) : <PortfolioGrid items={items} />}
        </div>
      </section>
      <ContactSection title="Un projet comme ceux-là ?" page="portfolio" />
      <SiteFooter />
    </div>
  )
}
